export const jobModule = {
  source: "Rapport - Module",
  causer: "Exécuté par",
  executedAt: "Exécuté le",
  finishedAt: "Terminé le",
  launchBtn: "Démarrer",
};
